import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Flexer, Button, Spacer, Feedback, Title } from '@ontruck/orc';

import { ExtrasSection, SummarySection } from 'modules/journey/EditForm/sections';

import { isSubmiting, getQuote } from 'redux/modules/journey-edit/selectors';

import { formChange } from 'redux/modules/journey-edit/effects';

import { ChangesHandler } from 'utils/formik';

import { TRIGGER_FORM_CHANGE } from 'modules/shipper-order/Form/constants';

import { StyledLoading } from './styled';
import { TenantExtras } from 'tenant/bussines';
import { injectIntl } from 'react-intl';

class JourneyCostForm extends Component {
  componentDidMount() {
    const { validateForm, setFieldValue } = this.props;
    /*
      This is only for trigger a change in the form,
      and then trigger a quote.
    */
    setFieldValue(TRIGGER_FORM_CHANGE, true);
    validateForm();
  }

  render() {
    const {
      initialValues,
      values,
      isValid,
      handleSubmit,
      submiting,
      formChange,
      quote,
      cancellationValues,
      readOnly,
      intl,
    } = this.props;
    const t = intl.messages.modules.journey.editForm;
    const { currency, route } = values;
    const activeExtras = TenantExtras?.activeExtras || [];

    return (
      <form onSubmit={handleSubmit}>
        {!readOnly && (
          <ExtrasSection
            cancellationValues={cancellationValues}
            currency={currency}
            route={route}
            activeExtras={activeExtras}
          />
        )}

        <Spacer mBottom="M">
          <Title text={t.price} size="XL" level="h2" />
          {quote.ready && (
            <SummarySection
              currency={currency}
              quote={quote}
              summaryType="cost"
              previousNetValue={initialValues.net_full_cost}
            />
          )}
        </Spacer>

        {(quote.loading || submiting) && (
          <Spacer mBottom="S">
            <StyledLoading />
          </Spacer>
        )}

        {quote.ready &&
          initialValues.net_full_cost &&
          Number(quote.net_full_cost) !== Number(initialValues.net_full_cost) && (
            <Spacer mBottom="M">
              <Feedback size="wideS" skin="warning">
                {t.alert_cost_change}
              </Feedback>
            </Spacer>
          )}
        {!readOnly && (
          <Flexer.Parent>
            <Flexer.Child>
              <Button
                type="submit"
                text={t.update}
                disabled={submiting || !isValid}
                dataE2E={`journey_detail__updateCost`}
              />
            </Flexer.Child>
          </Flexer.Parent>
        )}
        <ChangesHandler onChange={formChange} />
      </form>
    );
  }
}

JourneyCostForm.propTypes = {
  cancellationValues: PropTypes.array,
  values: PropTypes.object,
  isValid: PropTypes.bool,
  handleSubmit: PropTypes.func,
  submiting: PropTypes.bool,
  formChange: PropTypes.func,
  quote: PropTypes.object,
  initialValues: PropTypes.object,
  validateForm: PropTypes.func,
  setFieldValue: PropTypes.func,
};

JourneyCostForm.defaultProps = {
  values: {},
  initialValues: {},
  isValid: false,
  handleSubmit: () => {
    /*noop*/
  },
  submiting: false,
  formChange: () => {
    /*noop*/
  },
  quote: {},
};

const mapStateToProps = (state) => ({
  submiting: isSubmiting(state),
  quote: getQuote(state),
});

const actionCreators = {
  formChange,
};

export default injectIntl(connect(mapStateToProps, actionCreators)(JourneyCostForm));
